import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { KDService } from 'src/app/services/KD/kd.service';

@Component({
  selector: 'app-view-kd',
  templateUrl: './view-kd.component.html',
  styleUrl: './view-kd.component.css'
})
export class ViewKDComponent {

  constructor(private router: Router,
    private kdService: KDService) { }

  config: boolean = false;
  dateInterval: any
  updateInterval: any
  kdDocks: DocksModel[] = []
  dockId!: number
  selectedDock: number | any
  faFilter = faFilter

  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.kdService.getKDDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of({ kdDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.kdDocks = response.kdDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }


  changeDockPage() {
    if (this.selectedDock !== null) {
      // Fecha o modal e redireciona para o componente TripDetailsComponent
      this.config = false;
      this.router.navigate([`/view/KD/dock/${this.selectedDock}`]);
    }
  }
}
